<template>
  <div class="container1">
           <van-list
            ref="vanList"
            v-model="loading"
            :finished="finished"
            :finished-text="finishedText"
            @load="onLoad"
            class="wrapper"
            >
                <div class="reject" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.flowId)">
                    <!-- <div class="reject_item">
                        <p class="title_text">{{item.product}}</p>
                        <div class="info">
                            <span>所属区域:</span>
                            <span>{{item.geography}}</span>
                        </div>
                        <div class="info">
                            <span>商家名称:</span>
                            <span>{{item.shoppingStore}}</span>
                        </div>
                        <div class="info">
                            <span>退货人:</span>
                            <span>{{item.purchaser}}</span>
                        </div>
                        <div class="info">
                            <span>商品金额:</span>
                            <span>{{item.shoppingAmount}}</span>
                        </div>
                        <div class="info">
                            <span>商品类型:</span>
                            <span>{{item.productType | filt1}}</span>
                        </div>
                        <div class="info">
                            <span>退货时间:</span>
                            <span>{{item.refundTime|filt()}}</span>
                        </div>
                        <div class="info">
                            <span>退货单号:</span>
                            <span>{{item.orderNumber}}</span>
                        </div>
                        <div class="line"></div>
                        <div class="status">
                            <span class="left">{{item.statusText}}</span>
                            <div class="right">
                                    <span>查看更多</span>
                                    <img src="../../../../assets/image/right.png"/>
                            </div>
                        </div>
                    </div>
                    <div class="space"></div> -->
                    <div class="reject_item">
                        <div class="item_box">
                            <p class="title_text">{{item.product}}</p>
                            <div class="info">
                                <span>所属区域:</span>
                                <span>{{item.geography}}</span>
                            </div>
                            <div class="info">
                                <span>商家名称:</span>
                                <span>{{item.shoppingStore}}</span>
                            </div>
                            <div class="info">
                                <span>退货人:</span>
                                <span>{{item.purchaser}}</span>
                            </div>
                            <div class="info">
                                <span>商品金额:</span>
                                <span>{{item.shoppingAmount}}</span>
                            </div>
                            <div class="info">
                                <span>商品类型:</span>
                                <span>{{item.productType | filt1}}</span>
                            </div>
                            <div class="info">
                                <span>退货时间:</span>
                                <span>{{item.refundTime|filt()}}</span>
                            </div>
                            <div class="info">
                                <span>退货单号:</span>
                                <span>{{item.orderNumber}}</span>
                            </div>
                        </div>
                       <div class="line line_bottom"></div>
                        <div class="status">
                        <span class="left">{{item.statusText}}</span>
                            <div class="right">
                                    <span>查看更多</span>
                                    <img src="../../../../assets/image/right.png"/>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="space"></div> -->
                </div>

           </van-list>
           <div class="box1" v-if="isNolist">
                <img src='../../../../assets/empty/ic_wuxingxi.png'/>
                <p class="tip1">暂无数据</p>
            </div>
  </div>
</template>
<script>
    import util from '../../../../utils/common'
    import moment from 'moment'
    import api from '../../../../service/modules/refund'
    export default {
        data () {
            return {
                isShow: false,
                ischange: true,
                attention: this.$router.currentRoute.query.citycode,
                finished: false,
                finishedText: '没有更多',
                loading: false,
                pageIndex: '1',
                pageSize: '10',
                dataList: [],
                isNolist: false
            }
        },
        created () {
            this.getReturnList();
        },
        methods: {
            goHome () {
                this.$router.push('leader');
            },
            getReturnList () {
                api.returnList({ 'startDate': '',
                                 'endDate': '',
                                 'refundChannel': '',
                                 'areaId': '',
                                 'pageIndex': this.pageIndex,
                                 'pageSize': this.pageSize,
                                 'searchStr': '',
                                 'status': '',
                                 'refundType': '',
                                 'isCenterReceipt': '',
                                 'attention': '1' }).then((res) => {
                                     console.log(res);
                                     if (res.ret === 0) {
                                         this.finished = false;
                                         this.dataList = res.data.list;
                                         if (this.dataList.length === 0) {
                                             this.isNolist = true;
                                             this.finishedText = '';
                                         } else {
                                             this.isNolist = false;
                                         }
                                     }
                                 })
            },
            onLoad () {
                this.pageIndex++;
                api.returnList({ 'startDate': '',
                                 'endDate': '',
                                 'refundChannel': '',
                                 'areaId': '',
                                 'pageIndex': this.pageIndex,
                                 'pageSize': this.pageSize,
                                 'searchStr': '',
                                 'status': '',
                                 'refundType': '',
                                 'isCenterReceipt': '',
                                 'attention': '1' }).then((res) => {
                                     if (res.ret === 0) {
                                         setTimeout(() => {
                                             if (res.data.list.length > 0) {
                                                 this.dataList = this.dataList.concat(res.data.list);
                                                 this.loading = false;
                                             // this.aboutText="没有更多"
                                             } else {
                                                 this.loading = false;
                                                 this.finished = true;
                                             // this.aboutText="没有更多"
                                             }
                                         }, 500)
                                     }
                                 })
            },
            goDetail (value) {
                this.$store.state.refund.flowId = value;
                this.$router.push('/refund/refundDetail?flowId=' + value);
            }
        },
        filters: {
            filt (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
            },
            filt1 (value) {
                var config = util.getJsonLocal('configList').PRODUCT_TYPE || [];
                let name = '';
                config.forEach((item, index) => {
                    if (item.code === value) {
                        name = item.name
                    }
                })
                return name;
            },
            filt2 (value) {
                var config = util.getJsonLocal('configList').WORK_ORDER_FLOW;
                let name = '';
                config.map((item, index) => {
                    if (item.code === value) {
                        name = item.name
                    }
                })
                return name;
            }
        }
    }
</script>
<style scoped lang="scss">
.container1{
    width:100%;
    .reject {
      width: 100%;
      background-color: #fafafa;
      padding-top:16px;
      .reject_item {
        margin-left: 12px;
        margin-right: 12px;
        box-sizing: border-box;
        background-color: #ffffff;
        box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        .item_box {
          padding: 16px;
          .title_text {
            font-size: 16px;
            font-weight: 700;
            color: #2a2a2a;
            // margin-bottom: 16px;
            line-height: 24px;
          }
          .info {
            margin-top: 12px;
            span:nth-child(1) {
              display: inline-block;
              width: 65px;
              font-size: 14px;
              color: #777;
            }
            span:nth-child(2) {
              display: inline-block;
              font-size: 14px;
              color: #777;
              margin-left: 12px;
            }
          }
        }

        .line {
          width: 100%;
          height: 1px;
        }
        .status {
          width: 100%;
          padding: 15px 16px;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          justify-content: space-between;
          align-items: center;
          .left{
            font-size:14px;
            color:#333;
          }
          .right{
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            align-items: center;
            img{
              width:4px;
              height:7px;
              margin-left:6px;
              margin-top:-3px;
            }
            span{
               font-size:12px;
               color:#999;

            }
          }

        }
      }
      .space {
        width: 100%;
        height: 24px;
        background-color: #fafafa;
      }
    }
    .box1{
          text-align: center;
          height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          img{
               display: inline-block;
               width:74px;
               height:62px;
          }
          .tip1{
               font-size:14px;
               color:#9B9B9B;
               margin-top:28px;

          }
          .tip2{
               font-size:14px;
               color:#9B9B9B;
               margin-top:8px;
          }
     }

}
</style>
